import React from 'react';
import PropTypes from 'prop-types';
import { TOI_IMAGE_DOMAIN } from '../../../constants/index';
import s from './PersonaliseWidgetWithPoll.scss';

const PersonaliseWidgetWithPoll = props => {
  const {
    card,
    heading,
    section,
    subsection,
    msid,
    classname,
    disableWidget,
    stories,
  } = props;

  if (disableWidget) {
    return null;
  }

  return (
    <div
      className={`${s[classname]} ${s.perosnalwidget_wrap}`}
      data-card={card}
      data-heading={heading}
      data-section={section}
      data-subsection={subsection}
      id={`${card}_${msid}`}
      data-msid={msid}
    >
      <div className={`${s.horizontal_wrapper} ${s.listContainer}`}>
        <h5 className={s.text_read}>Top Picks For You</h5>
        {stories &&
          Array.isArray(stories) &&
          stories.length > 0 &&
          stories.map(ele => (
            <a
              className={`${s.horizontal_layout} ${s.cardWrapper}`}
              href={ele.wu || ele.value}
            >
              <div className={s.imageWrapper}>
                <img
                  className={s.image}
                  src={`${TOI_IMAGE_DOMAIN}/thumb/imgsize-${ele?.imageSize ||
                    '12345'},msid-${ele?.msid},width-200,resizemode-4/${
                    ele?.msid
                  }.jpg`}
                  alt={`articleShow ${ele?.msid}`}
                />
              </div>
              <div className={s.text_info}>
                <span className={s.heading}>{ele?.hl || ele?.title}</span>
              </div>
            </a>
          ))}
      </div>
    </div>
  );
};

PersonaliseWidgetWithPoll.propTypes = {
  card: PropTypes.string,
  section: PropTypes.string,
  subsection: PropTypes.string,
  msid: PropTypes.string,
  styleObj: PropTypes.shape({}),
  classname: PropTypes.string,
  disableWidget: PropTypes.bool,
  heading: PropTypes.string,
  dataset: PropTypes.shape({}),
  stories: PropTypes.shape({}),
};

PersonaliseWidgetWithPoll.defaultProps = {
  card: '',
  section: '',
  subsection: '',
  msid: '',
  styleObj: {},
  classname: '',
  disableWidget: false,
  heading: '',
  dataset: {},
  stories: {},
};

export default PersonaliseWidgetWithPoll;
